import { gql, useMutation } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import { LocalizedEditPackInput, LocalizedPack } from 'apollo/localizedTypes';

const EDIT_ENTRANCE_TICKET_TYPE = gql`
  mutation editPack($input: EditPackInput!) {
    editPack(input: $input) {
      id
      adultValue
      description {
        ...LocalizedTextFields
      }
      name {
        ...LocalizedTextFields
      }
      otherValue
      status
      visibility
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const useEditPackMutation = () => {
  return useMutation<{ editPack: LocalizedPack }, { input: LocalizedEditPackInput }>(
    EDIT_ENTRANCE_TICKET_TYPE,
    {}
  );
};
export default useEditPackMutation;
